

import Vue from 'vue'
import Icon from '../icon/index.vue'
export default Vue.extend({
	props:{
		text:{
			type: String,
			default:'无数据'
		}
	},
	components:{
		Icon
	}
})
